"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = void 0;
var jmespath_1 = __importDefault(require("jmespath"));
// note: fetch could be moved to context.$fetch
var fetch = function (data, path) {
    if (path === undefined) {
        return undefined;
    }
    if (path === '') {
        return data;
    }
    try {
        var value = jmespath_1.default.search(data, path);
        if (value === null) {
            return undefined; // unifying the returned value if no path or if path does not exist in object
        }
        return value;
    }
    catch (err) {
        throw new Error([
            "JMESPath query " + path + " returned the following error:",
            err.message
        ].join('\n'));
    }
};
exports.fetch = fetch;
//# sourceMappingURL=fetch.js.map